import {API_URL, THEME_COLOR, numberWithCommas} from "../../constant"
import React, {useEffect, useState} from 'react';
import { useLocalStorage } from "../../useLocalStorage";
import "./Reward.css";
import Cross from '../../images/icon/cross.png';
import toast, { Toaster } from 'react-hot-toast';

import voucherLogo from "../../images/icon/coupon.svg"


let Reward = (props)=>{
    const [token, setToken] = useLocalStorage("token", "");
    const [rewards, setRewards] = useState([]);
    const [selectedRewards, setSelectedRewards] = useState([]);
    const [totalReward, setTotalReward] = useState(0);

    const changeIsOpenReward = (val) => {
        props.changeIsOpenReward(val)
    }

    function initChecked(){
        let ttotal = 0;
        (props.rewards).forEach(element => {
            let obj = document.getElementById(`checkbox-reward-${element.ID}`);
            obj.checked = true;
            ttotal += parseInt(element.Amount);
        });
        setTotalReward( parseInt(ttotal))
        setSelectedRewards(props.rewards);
    }

    const ClickReward = (reward) =>{
        let IsChecked = document.getElementById(`checkbox-reward-${reward.ID}`).checked;
        let tselectedReward = [...selectedRewards];
        if(IsChecked){
            setTotalReward( parseInt(totalReward) + parseInt(reward.Amount))
            tselectedReward.push(reward);
        }else{
            setTotalReward( parseInt(totalReward) - parseInt(reward.Amount))
            tselectedReward = tselectedReward.filter((value, index) => value.ID !== reward.ID);
        }
        setSelectedRewards(tselectedReward);
    }
    
    function submitHandler(){
        props.setRewards(selectedRewards);
        props.setCoupons([]);
        props.setRewardAmount(totalReward);
        changeIsOpenReward(false);
        // console.log()
    }

    function getReward(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/reward`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }
    
    useEffect(async ()=>{
        let response = await getReward();
        if(response.status == 200){
            setRewards(response.data);
        }else{
            toast.error(response.message);
        }
        initChecked();
    },[]);
    return (
        <>
            <Toaster
                position="bottom-center"
            />
            <div className='reward-container'>
                {
                    (rewards.length == 0)? 
                    (
                        
                        <>
                            <div className="reward-flex-container">
                                <div style={{textAlign:"center", display:"none"}}>
                                    <img src={Cross}  style={{width: "40%"}}/>
                                </div>
                                <div style={{fontSize:"14pt"}}>Oh sorry, There's no reward ready for you</div>
                            </div>
                        </>
                    ):
                    (
                        rewards.map((value, index)=>{
                            let temp = selectedRewards.filter((val,idx)=> value.ID === val.ID);
                            return (
                                <div className={`reward-flex ${(index === rewards.length - 1) ? "reward-margin-bottom" : ""}`}>
                                    <div className='reward-left-image'>
                                        <div className='reward-voucher-container'>
                                            <img src={voucherLogo} alt="voucher-logo" />
                                        </div>
                                    </div>
                                    <div className='reward-name' style={{"flexGrow" :1}}>
                                        <div className='reward-code'>{value.Code}</div>
                                        <div>exp: {value.ExpiryDate}</div>
                                        <div className='reward-price'>Rp. {numberWithCommas(value.Amount)}</div>
                                    </div>
                                    <div className='reward-check-container'>
                                        <label>
                                            <input type="checkbox" id={`checkbox-reward-${value.ID}`} checked={temp && temp.length > 0} onClick={()=> ClickReward(value)}/>
                                            <span></span>
                                        </label>
                                    </div>
                                </div>
                            );
                        })
                    )
                }
            </div>
            <div className="reward-bottom">
                <div className="cart-footer">
                    <div className="" style={{"flexGrow":1}}>
                        <div className="cart-footer-sub">Total Reward</div><div className="cart-footer-price">Rp {numberWithCommas(totalReward)}</div>
                    </div>
                    <div style={{"margin": "5px 30px","textAlign":"center"}}>
                        <button className={`btn ${THEME_COLOR}`} onClick={()=> submitHandler()}>USE REWARD</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Reward;